export default class ScrollingWrapper extends HTMLElement
{
    constructor()
    {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.numElements = this.getAttribute('num-elements');
    }

    connectedCallback()
    {
        const template = document.querySelector('#scrolling-wrapper');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        let instance = template.content.cloneNode(true);
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        let scrollableElementTemplate = instance.querySelector('[name="scrollable-element"]');
        let scrollingWrapper = instance.querySelector('[name="scrolling-wrapper"]');
        let scrollableElement;

        for (let i = 1; i <= this.numElements; i++) {
            scrollableElement = scrollableElementTemplate.cloneNode(true);
            scrollableElement.querySelector('[name="scrollable-element-slot"]').setAttribute(
                'name',
                'scrollable-element-' + i
            );
            if (i == this.numElements) {
                scrollableElement.classList.add('last-scrollable-element');
            }
            scrollableElement.classList.add('scrollable-element');
            scrollingWrapper.appendChild(scrollableElement);
        }
        scrollableElementTemplate.remove();

        this._shadowRoot.appendChild(instance);
    }
}